'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export function CanonicalUrl() {
  const pathname = usePathname(),
    searchParams = useSearchParams(),
    [canonicalUrl, setCanonicalUrl] = useState<string | null>(null);

  useEffect(() => {
    const base = `${window.location.origin}${pathname}`,
      url = searchParams.size ? `${base}?${searchParams}` : base;
    setCanonicalUrl(url);
  }, [pathname, searchParams, canonicalUrl, setCanonicalUrl]);

  return <>{canonicalUrl && <link rel='canonical' href={canonicalUrl} />}</>;
}
